module.exports = __webpack_public_path__ + "static/img/30亿元.68b9ed1e.png";